<template>
  <v-card>
    <!--Barra superior que muestra cuanto tiempo queda para revisar la información de la persona más antigua sin revisar-->
    <div v-if="fecha_mas_antiguo != 99">
      <v-card-title>
        <h2 style="color: red">
          Siguiente vencimiento: {{ dia_mas_antiguo }} día,
          {{ hora_mas_antiguo }} horas, {{ minuto_mas_antiguo }} minutos
        </h2>
      </v-card-title>
      <hr />
    </div>

    <!--Menu superior para navegar entre los distintos datos disponibles para mostrar-->
    <v-card-text>
      <div class="text-xs-center">
        <v-btn slot="activator" color="primary" dark @click="elegir_general()"
          >Estado secretaria</v-btn
        >
        <v-btn
          slot="activator"
          color="primary"
          dark
          @click="elegir_documentos_iguales()"
          >Documentos iguales</v-btn
        >
        <v-btn slot="activator" color="primary" dark @click="elegir_global()"
          >Global</v-btn
        >
        <!--
        <v-btn slot="activator" color="primary" dark @click="elegir_por_dia()"
          >Por dia</v-btn
        >
        -->
        <v-menu transition="slide-y-transition" bottom>
          <v-btn slot="activator" color="primary" dark class="purple"
            >Unidades</v-btn
          >
          <v-list>
            <v-list-tile
              v-for="(unidad, i) in unidades"
              :key="unidad + i"
              @click="elegir_unidad(unidad, i)"
            >
              <v-list-tile-title>{{ unidad }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!--
        <v-btn slot="activator" color="primary" dark @click="elegir_salidas()"
          >Salidas unidades</v-btn
        >
        -->
      </div>
    </v-card-text>

    <!--Documentos repetidos-->
    <div v-if="pestana_elegida == -5">
      <h2>Documentos repetidos</h2>
      <div v-for="(pago, i) in arr_archivos_iguales_encontrados" :key="i">
        <li>{{ pago.id_inscripcion }} : {{ pago.documento }}</li>
      </div>
    </div>

    <!--Información global-->
    <div v-if="pestana_elegida == -4">
      <v-card-text>
        <h3>Asistentes por unidad</h3>
        <table style="border-spacing: 5px">
          <tr v-for="(cantidad, i) in total_por_unidad" :key="i">
            <td>{{ unidades[i] }}</td>
            <td>{{ cantidad }} de {{ unidades_previstos[i] }}</td>
            <td>
              <b
                >{{ ((cantidad / unidades_previstos[i]) * 100).toFixed(0) }}%</b
              >
            </td>
            <br />
          </tr>
        </table>
      </v-card-text>
      <hr />
      <v-card-text>
        <h3>Comensales el día de padres:</h3>
        Tendremos que poner y llenar <b>{{ comida_dia_padres }} platos</b>.
        <br />
        <h4>Intolerancias / Alergias/ Comentarios:</h4>
        <div
          v-for="(intolerancia, i) in comida_dia_padres_intolerancias"
          :key="i"
        >
          <li>{{ intolerancia }}</li>
        </div>
      </v-card-text>
    </div>

    <!--Información principal: Estado de secretaria-->
    <div v-if="pestana_elegida == -1">
      <!-- TO-DO:Hay otras formas de hacer esto pero todabia no las manejo -->
      <v-card-text>
        <h3>Personas inscritas:</h3>
        <br />{{ asistentes_totales }} apuntadas de
        {{ asistentes_esperados }} estimadas
        <v-progress-linear v-model="barra_asistentes"></v-progress-linear>
      </v-card-text>
      <hr />
      <v-card-text>
        <h3>Estado de las inscripciones:</h3>
        <b>Recibidas: {{ inscripciones_totales }}</b> <br />
        Por revisar: {{ inscripciones_registradas }}
        <v-progress-linear
          :value="barra_inscripciones_registradas"
          color="error"
          background-color="white"
        ></v-progress-linear>
        Pendientes de pago: {{ inscripciones_nopagadas }} /
        {{ inscripciones_nopagadas + inscripciones_pagadas }}
        <v-progress-linear
          :value="barra_inscripciones_nopagadas"
          color="yellow"
          background-color="success"
        ></v-progress-linear>
        <!-- Totales desactivadas <v-progress-linear :value="barra_inscripciones_pagadas" color="success" background-color="blue-grey"></v-progress-linear>-->
      </v-card-text>
      <v-card-text>
        <hr />
        <h3>Estado de la documentacion (por persona):</h3>
        Por revisar: {{ personas_unrevised }}
        <v-progress-linear
          :value="barra_personas_unrevised"
          color="error"
          background-color="white"
        ></v-progress-linear>
        Falta información: {{ personas_missing }} / {{ asistentes_totales }}
        <v-progress-linear
          :value="barra_personas_missing"
          color="yellow"
          background-color="success"
        ></v-progress-linear>
      </v-card-text>
      <hr />
      <v-card-text>
        <h3>
          Entre todos los inscritos pesamos tanto como
          {{ peso_elefante }} elefantes 🐘🐘🐘, eso es un monton!
        </h3>
        Han pasado el covid {{ this.covid_pasado }} personas, un
        {{ ((this.covid_pasado / asistentes_totales) * 100).toFixed(0) }}%
        <br />
        Estan vacunadas {{ this.covid_vacuna }} personas, un
        {{ ((this.covid_vacuna / asistentes_totales) * 100).toFixed(0) }}%
        <br />

        <b>{{ cumpleanos_total }} cumpleaños</b>, ve eligiendo la tarta🎂.
        <br />
        <b>{{ rama_ganadora }} es la rama poderosa! </b>
        {{ cantidad_rama_ganadora }} chavales van a campamento.
        <br />
        <img
          src="http://i.imgur.com/7zXpLPw.jpg"
          alt="Soy un elefante gigante"
          height="20%"
          width="20%"
        />
        <br />
        No todo van a ser datos aburridos... ;)
      </v-card-text>
    </div>
    <!--Información por unidad-->
    <div v-else-if="pestana_elegida >= 0">
      <!-- TO-DO:Hay otras formas de hacer esto pero todabia no las manejo -->
      <h1>{{ asistentes_por_unidad[pestana_elegida].unidad }}</h1>
      <hr />
      <v-card-text>
        <h2>
          Asistencia: {{ asistentes_por_unidad[pestana_elegida].dias[18] }}
        </h2>
        <table>
          <tr>
            <td>Ida</td>
            <td>15</td>
            <td>16</td>
            <td>17</td>
            <td>18</td>
            <td>19</td>
            <td>20</td>
            <td>21</td>
            <td>22</td>
            <td>23</td>
            <td>24</td>
            <td>25</td>
            <td>26</td>
            <td>27</td>
            <td>28</td>
            <td>29</td>
            <td>30</td>
            <td>Vuelta</td>
          </tr>
          <tr>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[16] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[0] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[1] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[2] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[3] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[4] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[5] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[6] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[7] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[8] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[9] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[10] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[11] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[12] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[13] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[14] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[15] }}
            </td>
            <td style="padding: 15px" class="text-xs-right">
              {{ asistentes_por_unidad[pestana_elegida].dias[17] }}
            </td>
          </tr>
        </table>
      </v-card-text>
      <hr />
      <v-card-text>
        <h2>Alergias:</h2>
        <v-data-table
          :headers="headers_tabla_unidad_alergias"
          :items="asistentes_por_unidad[pestana_elegida].alergias"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <!--<td>{{ props.item.name }} {{props.item.lastname}}</td>-->
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.lastname }}</td>
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.alergias }}</td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-text>
        <h2>Listado:</h2>
        <v-data-table
          :headers="headers_tabla"
          :items="filteredItems"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }} {{ props.item.lastname }}</td>

            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[16] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[0] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[1] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[2] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[3] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[4] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[5] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[6] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[7] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[8] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[9] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[10] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[11] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[12] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[13] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[14] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[15] }}
            </td>
            <td class="text-xs-right">
              {{ props.item.dias_en_campamento[17] }}
            </td>

            <td class="text-xs-right">{{ props.item.peso }}</td>
            <td class="text-xs-right">{{ props.item.alergias }}</td>
            <td class="text-xs-right">{{ props.item.operaciones }}</td>
            <td class="text-xs-right">{{ props.item.enfermedades }}</td>
            <td class="text-xs-right">{{ props.item.cumpleanos }}</td>

            <td class="text-xs-right">{{ props.item.autorizacion }}</td>
            <td class="text-xs-right">{{ props.item.cartilla_vacunacion }}</td>
            <td class="text-xs-right">{{ props.item.seguridad_social }}</td>
            <td class="text-xs-right">{{ props.item.salidad_extra }}</td>

            <td class="text-xs-right">{{ props.item.email }}</td>
            <td class="text-xs-right">{{ props.item.telefono1 }}</td>
            <td class="text-xs-right">{{ props.item.telefono2 }}</td>
            <td class="text-xs-right">{{ props.item.telefono3 }}</td>

            <td class="text-xs-right">{{ props.item.persona_id }}</td>
            <!--<td>{{ props.item.alergias }}</td>-->
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-text>
        <h2>Cumpleaños: 🎂🎂🎂🎉🎉🎉</h2>
        <v-data-table
          :headers="headers_tabla_unidad_cumpleaños"
          :items="cumpleaños_por_unidad[pestana_elegida].cumpleaños"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.lastname }}</td>
            <td>{{ props.item.dia }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </div>
    <!--Información por dia-->
    <div v-else-if="pestana_elegida == -2">
      <!-- TO-DO:Hay otras formas de hacer esto pero todavia no las manejo -->
      <v-card-title>
        <h2 style="color: red">ATENCIÓN: EN PRUEBAS</h2>
        <h2 style="color: red">
          Los datos no se guardan de una vez para otra, hay que ir a la pestaña
          "salidas unidades" y seleccionar cuando NO estan las unidades en
          campamento, tras ello ir a pestaña "por día" para ver los resultados
        </h2>
        <h3 style="color: red">
          Los scouters no son contabilizados en las salidas con sus unidades
        </h3>
      </v-card-title>
      <v-card-text>
        <h2>Listado:</h2>
        <div v-for="(numero, j) in 16" :key="j">
          <h3>Dia {{ numero }} - Desayuno</h3>
          <div v-for="(comida, i) in arr_comidas" :key="i">
            {{ comida.nombre }} : {{ arr_comidas[i].desayuno[j] }}
          </div>
          <h3>Dia {{ numero }} - Comida</h3>
          <div v-for="(comida, i) in arr_comidas" :key="i">
            {{ comida.nombre }} : {{ arr_comidas[i].comida[j] }}
          </div>
          <h3>Dia {{ numero }} - Cena</h3>
          <div v-for="(comida, i) in arr_comidas" :key="i">
            {{ comida.nombre }} : {{ arr_comidas[i].cena[j] }}
          </div>
        </div>
      </v-card-text>
      <!--TO-DO: Anadir tabla de asistentes por unidad-->
    </div>
    <!--Información salidas de unidades-->
    <div v-else-if="pestana_elegida == -3">
      <!-- TO-DO:Hay otras formas de hacer esto pero todabia no las manejo -->
      <v-card-title>
        <h2 style="color: red">ATENCIÓN: EN PRUEBAS</h2>
        <h2 style="color: red">
          Los datos no se guardan de una vez para otra, hay que ir a la pestaña
          "salidas unidades" y seleccionar cuando NO estan las unidades en
          campamento, tras ello ir a pestaña "por día" para ver los resultados
        </h2>
      </v-card-title>
      <div v-for="(unidad, i) in arr_salidas_por_unidad" :key="i">
        <v-card-text>
          <h2>{{ unidad.nombre }}</h2>
          <br />

          <h4>Desayuno</h4>
          <v-btn-toggle class="button--day" multiple v-model="unidad.desayunos">
            <v-btn
              class="button--day--item"
              large
              v-for="(desayuno, i) in unidad.desayunos"
              :key="i"
              @click="marcar_salida(unidad.nombre, 'desayuno', desayuno.fecha)"
            >
              {{ " " + desayuno.fecha + " " }}
            </v-btn>
          </v-btn-toggle>

          <h4>Comida</h4>
          <v-btn-toggle class="button--day" multiple v-model="unidad.comidas">
            <v-btn
              class="button--day--item"
              depressed
              v-for="(comida, i) in unidad.comidas"
              :key="i"
              @click="marcar_salida(unidad.nombre, 'comida', comida.fecha)"
            >
              {{ " " + comida.fecha + " " }}
            </v-btn>
          </v-btn-toggle>

          <h4>Cena</h4>
          <v-btn-toggle class="button--day" multiple v-model="unidad.cenas">
            <v-btn
              class="button--day--item"
              v-for="(cena, i) in unidad.cenas"
              :key="i"
              @click="marcar_salida(unidad.nombre, 'cena', cena.fecha)"
            >
              {{ " " + cena.fecha + " " }}
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "persons",
  data() {
    return {
      //Estos datos son necesarios para saber que penstaña/unidad esta eligiendo el usuario
      pestana_elegida: -1,
      unidad_elegida: "",

      //Este array se utiliza para marcar cuando una unidad esta o no en campamento, tendria que estar almacenado en la base de datos
      arr_salidas_por_unidad: [
        {
          nombre: "Cherokee",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Kiowa",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Chikay",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Dewanee",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Ethawa",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Segowlee",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Basiliscos",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Wargos",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Fenix",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Centauros",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Vorbassen",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Yangoru",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Clan",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Comuna",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Scouters",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
        {
          nombre: "Cabaña",
          desayunos: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          comidas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
          cenas: [
            { fecha: "14", estan: "1" },
            { fecha: "15", estan: "1" },
            { fecha: "16", estan: "1" },
            { fecha: "17", estan: "1" },
            { fecha: "18", estan: "1" },
            { fecha: "19", estan: "1" },
            { fecha: "20", estan: "1" },
            { fecha: "21", estan: "1" },
            { fecha: "22", estan: "1" },
            { fecha: "23", estan: "1" },
            { fecha: "24", estan: "1" },
            { fecha: "25", estan: "1" },
            { fecha: "26", estan: "1" },
            { fecha: "27", estan: "1" },
            { fecha: "28", estan: "1" },
            { fecha: "29", estan: "1" },
          ],
        },
      ],

      //Este array sirve para mostrar cuantos de cada rama hay por dia
      //Deberia generarse de una manera más sencilla o al menos no ser un dato a este nivel sino una variable creada solo cuando sea necesaria
      arr_comidas: [
        {
          nombre: "Castores",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Lobatos",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Tropa",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Mayores",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Scouter",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Cabaña",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
      ],

      //Array para contar asistentes por cada unidad
      total_por_unidad: [],

      //Contamos asistentes a comer el dia de padres
      comida_dia_padres: 0,
      comida_dia_padres_intolerancias: [],

      //Vamor para mostar el progreso de cantidad de inscripciones
      asistentes_esperados: 646,

      //Contador de asistentes totales para comparar con esperados
      asistentes_totales: 0,

      //Para mostrar datos graciosos
      peso_total: 0,
      peso_elefante: 0,
      covid_vacuna: 0,
      covid_pasado: 0,
      cumpleanos_total: 0,
      rama_poderosa: {
        castores: 0,
        lobatos: 0,
        tropa: 0,
      },
      rama_ganadora: "",
      cantidad_rama_ganadora: 0,

      //Barra para mostrar los asistentes
      barra_asistentes: 0,

      dia_comienzo_campamento: 15,
      personas: [],
      asistentes_por_unidad: [],
      cumpleaños_por_unidad: [],

      //Estados de las inscripciones
      inscripciones_totales: 0,
      inscripciones_registradas: 0,
      inscripciones_pagadas: 0,
      inscripciones_nopagadas: 0,

      //Barra para mostrar porcentajes, igual hay una forma mas limpia
      barra_inscripciones_registradas: 0,
      barra_inscripciones_pagadas: 0,
      barra_inscripciones_nopagadas: 0,

      //Estado de las personas
      personas_unrevised: 0,
      personas_missing: 0,
      personas_completed: 0,

      //Barra para mostrar porcentajes, igual hay una forma mas limpia
      barra_personas_unrevised: 0,
      barra_personas_missing: 0,
      barra_personas_completed: 0,

      //Guardamos la hora de la persona mas antigua con el estado unrevised
      fecha_mas_antiguo: 99, //Inicializamos a valor mas alto que 2 para que se pueda ir cogiendo el mas bajo
      dia_mas_antiguo: 0,
      hora_mas_antiguo: 0,
      minuto_mas_antiguo: 0,

      //Array para guardar las inscripciones con los mismos documentos
      arr_archivos_iguales_buscando: [],
      arr_archivos_iguales_encontrados: [],

      unidades: [
        "Cherokee",
        "Kiowa",
        "Chikay",
        "Dewanee",
        "Ethawa",
        "Segowlee",
        "Basiliscos",
        "Centauros",
        "Fenix",
        "Wargos",
        "Imohag",
        "Keltisch",
        "Kreen Akrore",
        "Clan",
        "Comuna",
        "Scouter",
        "Cabaña",
        "Ardillas",
        "Viejos Lobos",
      ],

      //Unidades previstos para comparar su estado
      unidades_previstos: [
      30, 32, 24, 23, 25, 27, 22, 27, 16, 28, 20, 25, 25, 30, 25, 77, 70, 0, 20
      ],

      //Headers de tablas
      headers_tabla_unidad_alergias: [
        { text: "Nombre", align: "left", sortable: false, value: " name" },
        { text: "Apellido", align: "left", sortable: false, value: "lastname" },
        {
          text: "Id secretaria",
          align: "left",
          sortable: false,
          value: "alergias",
        },
        { text: "Alergia", align: "left", sortable: false, value: "alergias" },
      ],
      headers_tabla_unidad_cumpleaños: [
        { text: "Nombre", align: "left", sortable: false, value: " name" },
        { text: "Apellido", align: "left", sortable: false, value: "lastname" },
        { text: "Dia", align: "left", sortable: false, value: "dia" },
      ],
      headers_tabla: [
        {
          text: "Nombre y Apellido ",
          align: "left",
          sortable: true,
          value: "name",
        },
        //{ text: 'Apellidos',sortable: true, value: 'lastname'},
        { text: "Ida", sortable: false, value: "dias_en_campamento[16]" },
        { text: "15", sortable: false, value: "dias_en_campamento[0]" },
        { text: "16", sortable: false, value: "dias_en_campamento[1]" },
        { text: "17", sortable: false, value: "dias_en_campamento[2]" },
        { text: "18", sortable: false, value: "dias_en_campamento[3]" },
        { text: "19", sortable: false, value: "dias_en_campamento[4]" },
        { text: "20", sortable: false, value: "dias_en_campamento[5]" },
        { text: "21", sortable: false, value: "dias_en_campamento[6]" },
        { text: "22", sortable: false, value: "dias_en_campamento[7]" },
        { text: "23", sortable: false, value: "dias_en_campamento[8]" },
        { text: "24", sortable: false, value: "dias_en_campamento[9]" },
        { text: "25", sortable: false, value: "dias_en_campamento[10]" },
        { text: "26", sortable: false, value: "dias_en_campamento[11]" },
        { text: "27", sortable: false, value: "dias_en_campamento[12]" },
        { text: "28", sortable: false, value: "dias_en_campamento[13]" },
        { text: "29", sortable: false, value: "dias_en_campamento[14]" },
        { text: "30", sortable: false, value: "dias_en_campamento[15]" },
        { text: "Vuelta", sortable: false, value: "dias_en_campamento[17]" },
      ],
    };
  },
  /* NO ESTOY USANDO FIRESTORE
        firestore () {
            return {
                personas: this.$db.collection('forms').doc('inscripciones').collection('answers')
            }
        },
        */
  created() {
    //Inicializamos el array de asistentes por unidad
    for (var j = 0; j < this.unidades.length; j++) {
      //17 dias de campamento
      this.asistentes_por_unidad.push({
        unidad: this.unidades[j],
        dias: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        alergias: [],
        id: "0",
      });
    }

    //Inicializamos el array de cumpleaños por unidad
    for (var j = 0; j < this.unidades.length; j++) {
      //17 dias de campamento
      this.cumpleaños_por_unidad.push({
        unidad: this.unidades[j],
        cumpleaños: [],
      });
    }

    var out = this.$db
      .collection("forms")
      .doc("inscripciones")
      .collection("answers")
      //.where('email', '==', "alberto.gonzalez.gomez@hotmail.com") //Filtro
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          //COMENZAMOS CONTANDO LOS DATOS PARA CADA RESERVA
          //Cada reserva puede tener varias personas asocidas

          //console.log('Incscripcion ',doc.id, '=>', doc.data());
          //console.log(doc.id, '=>', doc.data().peopleNumber);
          this.inscripciones_totales = this.inscripciones_totales + 1; //Contamos el numero de inscripciones
          this.asistentes_totales =
            this.asistentes_totales + doc.data().peopleNumber; //Contamos cuantas personas van a campamento

          //Contamos cuantos comen en campamento el dia de padres
          var recoger_comida_dia_padres = 0;
          if (doc.data() && doc.data().extre && doc.data().extre.lunch) {
            recoger_comida_dia_padres = parseInt(doc.data().extre.lunch);
          }
          if (recoger_comida_dia_padres > 0) {
            this.comida_dia_padres =
              this.comida_dia_padres + recoger_comida_dia_padres;
          }
          //Comentarios del dia de padres
          if (doc.data().extre && doc.data().extre.comentarios != null) {
            this.comida_dia_padres_intolerancias.push(
              doc.data().extre.comentarios
            );
          }

          //TO-DO: DUDA, calcular esto de manera dinamica es una castrofe
          this.barra_asistentes =
            (this.asistentes_totales / this.asistentes_esperados) * 100;

          //Vemos en que estado esta cada inscipcion y las contamos
          var estado_inscripcion = doc.data().status;

          if (estado_inscripcion == "REGISTRERED") {
            this.inscripciones_registradas++;
          }
          if (estado_inscripcion == "Pagado") {
            this.inscripciones_pagadas++;
          }
          if (estado_inscripcion == "No paided") {
            this.inscripciones_nopagadas++;
          }

          //TO-DO: DUDA, calcular esto de manera dinamica es una castrofe
          this.barra_inscripciones_registradas =
            (this.inscripciones_registradas / this.inscripciones_totales) * 100;
          this.barra_inscripciones_pagadas =
            (this.inscripciones_pagadas / this.inscripciones_totales) * 100;
          this.barra_inscripciones_nopagadas =
            (this.inscripciones_nopagadas /
              (this.inscripciones_pagadas +
                this.barra_inscripciones_nopagadas)) *
            100;

          //Extraemos la hora
          var hora_inscripcion_creada = doc.data().created;

          /************************************EN BUSCA DE NOMBRES DE FICHEROS IGUALES*/
          //Recogemos la factura
          var recoger_factura = doc.data().recipe;
          //console.log(recoger_factura);

          var este_tiene_iguales = false;
          //Vemos si ya esta incluido este nombre en la lista
          for (var m = 0; m < this.arr_archivos_iguales_buscando.length; m++) {
            if (
              this.arr_archivos_iguales_buscando[m].documento == recoger_factura
            ) {
              //Encontrado_igual es para que no saque varias veces que es igual si se llaman igual mas de dos
              //console.log("DOCUMENTOS IGUALES")
              //console.log(this.arr_archivos_iguales_buscando[m].id_inscripcion, ' == ', doc.id);
              //console.log(this.arr_archivos_iguales_buscando[m].documento , " == " , recoger_factura);
              if (this.arr_archivos_iguales_buscando[m].marcado == false) {
                this.arr_archivos_iguales_buscando[m].marcado = true;
                this.arr_archivos_iguales_encontrados.push({
                  id_inscripcion:
                    this.arr_archivos_iguales_buscando[m].id_inscripcion,
                  documento: this.arr_archivos_iguales_buscando[m].documento,
                });
              }
              //Añadimos el nuevo
              if (este_tiene_iguales == false) {
                this.arr_archivos_iguales_encontrados.push({
                  id_inscripcion: doc.id,
                  documento: recoger_factura,
                });
                //Apuntamos que este esta repetido
                este_tiene_iguales = true;
              }
            }
          }

          //Añadimos en el listado el siguiente documento
          if (este_tiene_iguales == false) {
            if (recoger_factura != null) {
              this.arr_archivos_iguales_buscando.push({
                id_inscripcion: doc.id,
                documento: recoger_factura,
                marcado: false,
              });
            }
          } else {
            if (recoger_factura != null) {
              this.arr_archivos_iguales_buscando.push({
                id_inscripcion: doc.id,
                documento: recoger_factura,
                marcado: true, //Esto es lo que cambia
              });
            }
          }

          //console.log(this.arr_archivos_iguales_buscando);
          /************************************FIN BUSCA DE NOMBRES DE FICHEROS IGUALES*/

          //var estado = this.status;
          var inscripcion = doc.data();

          for (var i = 0; i < doc.data().peopleNumber; i++) {
            //console.log(doc.data().people[i].id)

            //Es necesaria la segunda declaracion, la primera provoca un cambio de ambito de this
            //doc.data().people[0].get().then(function(doc) {
            console.log(doc.data());
            doc
              .data()
              .people[i].get()
              .then((doc) => {
                if (doc.exists) {
                  //Trazas de lo que se recibe
                  //console.log("Datos personales:", doc.data());

                  //console.log('People ',doc.id, ' => ', doc.data());

                  //Recogemos lo recibido de doc.data() para tratar con ello de manera amigable
                  var alergias = doc.data().alergias;
                  var operaciones = doc.data().operaciones;
                  var enfermedades = doc.data().enfermedades;
                  var name = doc.data().name;
                  var lastname = doc.data().lastname;
                  var unidad = doc.data().unidad;
                  var status = doc.data().status;
                  var peso = doc.data().peso;
                  var cumpleanos = doc.data().birthday;
                  var rama = doc.data().rama;

                  if (status == "unrevised") {
                    console.log("People ", doc.id, " => ", doc.data());
                  }

                  var autorizacion = doc.data().autorizacion;
                  var cartilla_vacunacion = doc.data().cartilla_vacunacion;
                  var seguridad_social = doc.data().seguridad_social;
                  var salidad_extra = doc.data().docs;

                  var persona_id = doc.data().id;

                  //En inscripcion tenemos los datos de cada inscripcion
                  var email = inscripcion.email;
                  var telefono1 = inscripcion.phone;
                  var telefono2 = inscripcion.phone2;
                  var telefono3 = inscripcion.phone3;

                  var arr_documentos = [];
                  arr_documentos.push(autorizacion);
                  arr_documentos.push(cartilla_vacunacion);
                  arr_documentos.push(seguridad_social);

                  /************************************EN BUSCA DE NOMBRES DE FICHEROS IGUALES*/
                  for (var n = 0; n < arr_documentos.length; n++) {
                    recoger_factura = arr_documentos[n];
                    var este_tiene_iguales = false;

                    //Vemos si ya esta incluido este nombre en la lista
                    for (
                      var m = 0;
                      m < this.arr_archivos_iguales_buscando.length;
                      m++
                    ) {
                      if (
                        this.arr_archivos_iguales_buscando[m].documento ==
                        recoger_factura
                      ) {
                        //Encontrado_igual es para que no saque varias veces que es igual si se llaman igual mas de dos
                        //console.log("DOCUMENTOS IGUALES")
                        //console.log(this.arr_archivos_iguales_buscando[m].id_inscripcion, ' == ', doc.id);
                        //console.log(this.arr_archivos_iguales_buscando[m].documento , " == " , recoger_factura);
                        if (
                          this.arr_archivos_iguales_buscando[m].marcado == false
                        ) {
                          this.arr_archivos_iguales_buscando[m].marcado = true;
                          this.arr_archivos_iguales_encontrados.push({
                            id_inscripcion:
                              this.arr_archivos_iguales_buscando[m]
                                .id_inscripcion,
                            documento:
                              this.arr_archivos_iguales_buscando[m].documento,
                          });
                        }
                        //Añadimos el nuevo
                        if (este_tiene_iguales == false) {
                          this.arr_archivos_iguales_encontrados.push({
                            id_inscripcion: doc.id,
                            documento: recoger_factura,
                          });
                          //Apuntamos que este esta repetido
                          este_tiene_iguales = true;
                        }
                      }
                    }

                    //Añadimos en el listado el siguiente documento
                    if (este_tiene_iguales == false) {
                      if (recoger_factura != null) {
                        this.arr_archivos_iguales_buscando.push({
                          id_inscripcion: doc.id,
                          documento: recoger_factura,
                          marcado: false,
                        });
                      }
                    } else {
                      if (recoger_factura != null) {
                        this.arr_archivos_iguales_buscando.push({
                          id_inscripcion: doc.id,
                          documento: recoger_factura,
                          marcado: true, //Esto es lo que cambia
                        });
                      }
                    }
                  }
                  /************************************FIN BUSCA DE NOMBRES DE FICHEROS IGUALES*/

                  //Escultas, scouters y cabaña no tienen unidad sino rama
                  /*
                                    if (doc.data().rama == "Escultas"){
                                        unidad = "Escultas";
                                    }
                                    */
                  if (doc.data().rama == "Cabaña") {
                    unidad = "Cabaña";
                  }
                  if (doc.data().rama == "Scouter") {
                    unidad = "Scouter";
                  }

                  //Contamos el peso del grupo
                  if (peso > 0 && peso < 100) {
                    this.peso_total = this.peso_total + parseInt(peso);
                    this.peso_elefante = (this.peso_total / 6000).toFixed(2);
                  } else {
                    this.peso_total = this.peso_total + 65;
                    this.peso_elefante = (this.peso_total / 6000).toFixed(2);
                  }

                  //Contamos covid
                  if (
                    doc.data().covid_disease &&
                    doc.data().covid_disease == "Si"
                  ) {
                    this.covid_pasado = this.covid_pasado + 1;
                  }
                  if (
                    doc.data().covid_vaccine &&
                    (doc.data().covid_vaccine == "Si, pauta completa" ||
                      doc.data().covid_vaccine == "Si, pauta parcial")
                  ) {
                    this.covid_vacuna = this.covid_vacuna + 1;
                  }

                  //Contamos cumpleanos
                  var partir_cumpleanos = cumpleanos.split("-");
                  var mes = partir_cumpleanos[1];
                  var dia = parseInt(partir_cumpleanos[2]);
                  if (mes == "07" && dia >= 14 && dia <= 29) {
                    this.cumpleanos_total = this.cumpleanos_total + 1;
                    //console.log(name);
                    //console.log(lastname);
                    //console.log(unidad);
                    //console.log(dia);
                    var id_unidad = this.obtener_id_unidad(unidad); //Funcion para obtener la unidad
                    //Recogemos los cumpleaños de esas unidad
                    this.cumpleaños_por_unidad[id_unidad].cumpleaños.push({
                      name: name,
                      lastname: lastname,
                      dia: dia,
                    });
                    console.log(this.cumpleaños_por_unidad);
                  }
                  //Contamos la rama poderosa
                  if (rama == "Castores") {
                    this.rama_poderosa.castores =
                      this.rama_poderosa.castores + 1;
                  }
                  if (rama == "Lobatos") {
                    this.rama_poderosa.lobatos = this.rama_poderosa.lobatos + 1;
                  }
                  if (rama == "Tropa") {
                    this.rama_poderosa.tropa = this.rama_poderosa.tropa + 1;
                  }
                  if (
                    this.rama_poderosa.castores > this.rama_poderosa.lobatos &&
                    this.rama_poderosa.castores > this.rama_poderosa.tropa
                  ) {
                    this.rama_ganadora = "Castores";
                    this.cantidad_rama_ganadora = this.rama_poderosa.castores;
                  }
                  if (
                    this.rama_poderosa.lobatos > this.rama_poderosa.castores &&
                    this.rama_poderosa.lobatos > this.rama_poderosa.tropa
                  ) {
                    this.rama_ganadora = "Lobatos";
                    this.cantidad_rama_ganadora = this.rama_poderosa.lobatos;
                  }
                  if (
                    this.rama_poderosa.tropa > this.rama_poderosa.castores &&
                    this.rama_poderosa.tropa > this.rama_poderosa.lobatos
                  ) {
                    this.rama_ganadora = "Tropa";
                    this.cantidad_rama_ganadora = this.rama_poderosa.tropa;
                  }

                  //Vemos en que estado esta cada inscipcion y las contamos
                  var estado_inscripcion = doc.data().status;

                  if (status == "unrevised") {
                    this.personas_unrevised++;
                  }
                  if (status == "Missing") {
                    this.personas_missing++;
                  }
                  if (status == "Completed") {
                    this.personas_completed++;
                  }

                  //TO-DO: DUDA, calcular esto de manera dinamica es una castrofe
                  this.barra_personas_unrevised =
                    (this.personas_unrevised / this.asistentes_totales) * 100;
                  this.barra_personas_missing =
                    (this.personas_missing / this.asistentes_totales) * 100;

                  if (status == "unrevised") {
                    //No pueden pasar mas de 48 horas con una inscripcion en unrevised
                    var fecha_actual = new Date();

                    var diff_fecha = fecha_actual - hora_inscripcion_creada;
                    var diff_fecha =
                      hora_inscripcion_creada -
                      fecha_actual +
                      1000 * 60 * 60 * 24 * 2; //Sumo 48 horas

                    //if(diff_fecha/(1000*60*60*24) < 2){
                    if (diff_fecha / (1000 * 60 * 60 * 24) > 0) {
                      //Si han pasado las 48 horas de perdidos al rio, o al menos en las pruebas
                      if (
                        diff_fecha / (1000 * 60 * 60 * 24) <
                        this.fecha_mas_antiguo
                      ) {
                        this.fecha_mas_antiguo =
                          diff_fecha / (1000 * 60 * 60 * 24);
                        this.dia_mas_antiguo = parseInt(
                          diff_fecha / (1000 * 60 * 60 * 24)
                        );
                        this.hora_mas_antiguo = parseInt(
                          diff_fecha / (1000 * 60 * 60) -
                            24 * this.dia_mas_antiguo
                        );
                        this.minuto_mas_antiguo = parseInt(
                          diff_fecha / (1000 * 60) -
                            60 * 24 * this.dia_mas_antiguo -
                            60 * this.hora_mas_antiguo
                        );
                      }
                    }
                  }

                  //RECOGEMOS LA INFORMACION PARA CADA PERSONA
                  //Guardamos en el objeto la informacion recibida para cada persona
                  //No guardamos toda, por ahora solo la que vamos usar

                  //Antes tenemos que saber que dias viene a campamento
                  //Guardamos en el array que dias esta
                  var recoger_dias_en_campamento = [];
                  for (var j = 0; j < 17; j++) {
                    //0 a 15 son dias de campa + 16 y 17 bus
                    //recoger_dias_en_campamento.push(0);
                    recoger_dias_en_campamento.push("");
                  }

                  //Obtenemos de que unidad numerica es
                  var id_unidad = this.obtener_id_unidad(unidad); //Funcion para obtener la unidad
                  //console.log(id_unidad);

                  //Recogemos las alergias para esta unidad
                  this.asistentes_por_unidad[id_unidad].alergias.push({
                    name: name,
                    lastname: lastname,
                    alergias: alergias,
                    id: doc.id, //id: cumpleanos
                  });

                  //Con que venga un dia a campamente lo apuntamos como que viene
                  var valor_anterior_asistentes_unidad =
                    this.asistentes_por_unidad[id_unidad].dias[18];
                  this.$set(
                    this.asistentes_por_unidad[id_unidad].dias,
                    18,
                    valor_anterior_asistentes_unidad + 1
                  );

                  //Dias
                  for (var j = 0; j < doc.data().days.length; j++) {
                    var traduccion_dia_a_array =
                      doc.data().days[j] - this.dia_comienzo_campamento;

                    //ANADIMOS AL CONTADOR PERSONAL
                    //recoger_dias_en_campamento[ traduccion_dia_a_array ]++;
                    recoger_dias_en_campamento[traduccion_dia_a_array] = "X";

                    //ANADIMOS AL CONTADOR POR UNIDAD
                    //var id_unidad = this.obtener_id_unidad(doc.data().unidad);  //Funcion para obtener la unidad
                    //El metodo normal de Javascript no funciona, no tendria reactividad
                    //this.asistentes_por_unidad[id_unidad].dias[traduccion_dia_a_array]++;
                    var valor_anterior_dia =
                      this.asistentes_por_unidad[id_unidad].dias[
                        traduccion_dia_a_array
                      ];
                    this.$set(
                      this.asistentes_por_unidad[id_unidad].dias,
                      traduccion_dia_a_array,
                      valor_anterior_dia + 1
                    );
                    //this.$set(this.asistentes_por_unidad[j], "unidad", "Patata")
                  }
                  //BUS
                  for (var j = 0; j < doc.data().bus.length; j++) {
                    //ANADIMOS AL CONTADOR POR UNIDAD
                    //var id_unidad = this.obtener_id_unidad(doc.data().unidad);  //Funcion para obtener la unidad
                    //No funciona, no seria reactivo if (doc.data().bus[j] == "vuelta") {this.asistentes_por_unidad[id_unidad].dias[ 16 ]++}
                    if (doc.data().bus[j] == "ida") {
                      var valor_anterior_ida =
                        this.asistentes_por_unidad[id_unidad].dias[16];
                      this.$set(
                        this.asistentes_por_unidad[id_unidad].dias,
                        16,
                        valor_anterior_ida + 1
                      );
                      //ANADIMOS AL CONTADOR PERSONAL
                      recoger_dias_en_campamento[16] = "X";
                    }
                    //No funciona, no seria reactivo if (doc.data().bus[j] == "ida") {this.asistentes_por_unidad[id_unidad].dias[ 17 ]++}
                    if (doc.data().bus[j] == "vuelta") {
                      var valor_anterior_vuelta =
                        this.asistentes_por_unidad[id_unidad].dias[17];
                      this.$set(
                        this.asistentes_por_unidad[id_unidad].dias,
                        17,
                        valor_anterior_vuelta + 1
                      );
                      //ANADIMOS AL CONTADOR PERSONAL
                      recoger_dias_en_campamento[17] = "X";
                    }
                  }

                  //TO-DO: dias_en_campamento
                  //console.log(doc.data().name);
                  //this.personas.push(this.persona)
                  this.personas.push({
                    unidad: unidad,
                    status: status,
                    alergias: alergias,
                    name: name,
                    lastname: lastname,
                    dias_en_campamento: recoger_dias_en_campamento,
                    autorizacion: autorizacion,
                    operaciones: operaciones,
                    enfermedades: enfermedades,
                    peso: peso,
                    cumpleanos: cumpleanos,
                    cartilla_vacunacion: cartilla_vacunacion,
                    seguridad_social: seguridad_social,
                    salidad_extra: salidad_extra,
                    email: email,
                    telefono1: telefono1,
                    telefono2: telefono2,
                    telefono3: telefono3,
                    persona_id: persona_id,
                  });
                  //console.log(this.personas)

                  //Contamos cuantos hay de cherokee
                  for (var j = 0; j < this.unidades.length; j++) {
                    //console.log(this.unidades[j]);
                    var cantidad = this.personas.filter(
                      (persona) => persona.unidad == this.unidades[j]
                    );
                    this.total_por_unidad[j] = cantidad.length;
                  }

                  //console.log(this.asistentes_por_unidad);
                } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
                }
              })
              .catch(function (error) {
                console.log("Error getting document:", error);
              });
          }
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });
  },
  methods: {
    obtener_id_unidad(nombre_unidad) {
      var unidad_numerica = -1;
      //console.log("En funcion obtener_id_unidad");
      for (var j = 0; j < this.unidades.length; j++) {
        if (this.unidades[j] == nombre_unidad) {
          unidad_numerica = j;
        }
      }
      return unidad_numerica;
    },
    elegir_general() {
      this.pestana_elegida = -1;
    },
    elegir_por_dia() {
      this.pestana_elegida = -2;
      //console.log(this.pestana_elegida);
      //console.log("Ejecutamos contar");
      this.contar();
    },
    elegir_global() {
      this.pestana_elegida = -4;
    },
    elegir_unidad(unidad, id_unidad) {
      //console.log("Hola desde funcion 1");
      //console.log(unidad);
      //console.log(id_unidad);
      this.pestana_elegida = id_unidad;
      this.unidad_elegida = unidad;
    },

    elegir_salidas(unidad, id_unidad) {
      this.pestana_elegida = -3;
      //console.log(this.pestana_elegida);
    },
    elegir_documentos_iguales() {
      this.pestana_elegida = -5;
    },
    contar() {
      //Ponemos contadores a cero
      //Mejor hacer esto con ifs, lo que hay es feisimo
      this.arr_comidas = [
        {
          nombre: "Castores",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Lobatos",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Tropa",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Mayores",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Scouter",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
        {
          nombre: "Cabaña",
          desayuno: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          comida: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
          cena: [
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
            "0",
          ],
        },
      ];

      //console.log("Estoy en contar");
      //Recorro los dias
      for (
        var persona_id = 0;
        persona_id < this.personas.length;
        persona_id++
      ) {
        var unidad = this.personas[persona_id].unidad;
        var rama = this.personas[persona_id].unidad; //Necesaria para scouters y cabaña
        //console.log(unidad);
        var id_unidad = this.obtener_id_unidad(unidad); //Funcion para obtener la unidad
        for (var dia = 0; dia <= 14; dia++) {
          if (this.personas[persona_id].dias_en_campamento[dia] == "X") {
            //Tenemos desayuno comida y cena para cada uno de los dias
            var id_rama = -1;
            if (unidad == "Cherokee" || unidad == "Kiowa") {
              id_rama = 0;
            }
            if (
              unidad == "Chikay" ||
              unidad == "Dewanee" ||
              unidad == "Ethawa" ||
              unidad == "Segowlee"
            ) {
              id_rama = 1;
            }
            if (
              unidad == "Basiliscos" ||
              unidad == "Wargos" ||
              unidad == "Fenix" ||
              unidad == "Centauros"
            ) {
              id_rama = 2;
            }
            if (
              unidad == "Escultas" ||
              unidad == "Clan" ||
              unidad == "Comuna"
            ) {
              id_rama = 3;
            }
            if (rama == "Scouter") {
              id_rama = 4;
            }
            if (rama == "Cabaña") {
              id_rama = 5;
            }

            //Anadimos a la unidad apropiada
            if (
              this.arr_salidas_por_unidad[id_unidad].desayunos[dia].estan == 1
            ) {
              this.arr_comidas[id_rama].desayuno[dia]++;
            }
            if (
              this.arr_salidas_por_unidad[id_unidad].comidas[dia].estan == 1
            ) {
              this.arr_comidas[id_rama].comida[dia]++;
            }
            if (this.arr_salidas_por_unidad[id_unidad].cenas[dia].estan == 1) {
              this.arr_comidas[id_rama].cena[dia]++;
            }
          }
        }
      }
      //console.log(this.arr_comidas);
    },
    marcar_salida(nombre, momento, fecha) {
      //(unidad.nombre,'desayunos',desayuno.fecha)"
      //console.log(nombre);
      //console.log(momento);
      //console.log(fecha);
      var id_unidad = this.obtener_id_unidad(nombre); //Funcion para obtener la unidad
      //console.log(this.arr_salidas_por_unidad[id_unidad].desayunos[fecha-14])
      if (momento == "desayuno") {
        this.$set(
          this.arr_salidas_por_unidad[id_unidad].desayunos[fecha - 14],
          "estan",
          "0"
        );
      }
      if (momento == "comida") {
        this.$set(
          this.arr_salidas_por_unidad[id_unidad].comidas[fecha - 14],
          "estan",
          "0"
        );
      }
      if (momento == "cena") {
        this.$set(
          this.arr_salidas_por_unidad[id_unidad].cenas[fecha - 14],
          "estan",
          "0"
        );
      }
      //this.$set(this.asistentes_por_unidad[id_unidad].dias, traduccion_dia_a_array, valor_anterior_dia +1)
      //console.log(this.arr_salidas_por_unidad);
    },
  },
  computed: {
    //doc.data().people[0].get().then(function(doc) {
    //doc.data().people[0].get().then(doc => { //Esta si

    filteredItems() {
      return this.personas.filter((persona) => {
        return persona.unidad === this.unidad_elegida;
      });
      /*
                return this.personas.filter((i) => {
                    console.log(this.unidad_elegida)
                    return !this.unidad_elegida || (i.unidad === this.unidad);
                })
                */
    },
  },
};
/*
    this.$db.collection("forms").doc("inscripciones").set({
    */
</script>

<style scoped>
</style>